<template>
  <div id="PlaceAnOrderRequestForm">
    <div class="row" id="order-d-main-section">
      <div class="row">
        <div class="col-md-12">
          <PlaceAnOrder
            v-show="currentStepName == 'Import List'"
            ref="placeAnOrderRef"
            @set-imported-products="setImportedProducts"
            @show-next-step="checkNextStep"
          />
          <ConfirmOrder
            v-show="currentStepName == 'Confirmation'"
            :ImportedProductData="ImportedProductData"
            ref="confirmOrderRef"
          />
        </div>
      </div>
    </div>
    <div class="row" id="customStepperSection">
      <div class="col-md-12">
        <CustomStepper
          :steps="steps"
          :currentStepIdx.sync="currentStepIdx"
          :currentStepName="currentStepName"
          :completedStepIdx="completedStepIdx"
          :requiredFieldNeeded="!IsCurrentStepValid"
          :continueBtnHoverText="continueBtnHoverText"
          :diabledToolTip="diabledToolTip"
          @show-last-step="currentStepIdx--"
          @show-next-step="checkNextStep"
          @hide-modal="hideModal"
        />
      </div>
    </div>
    <DxLoadPanel
      :position="loaderPosition"
      :visible.sync="loaderVisible"
      :show-indicator="true"
      shading-color="rgba(0,0,0,0.4)"
      :delay="250"
      :shading="true"
    />
  </div>
</template>
<script>
import { EventBus } from "../../components/Events.js";
import notify from "devextreme/ui/notify";
import CustomStepper from "../../views/stepper/CustomStepper.vue";
import { DxLoadPanel } from "devextreme-vue/load-panel";
import PlaceAnOrder from "../../views/placeAnOrderRequest/placeAnOrder/PlaceAnOrder";
import ConfirmOrder from "../../views/placeAnOrderRequest/confirmOrder/ConfirmOrder";
export default {
  name: "PlaceAnOrderRequestForm",
  components: {
    CustomStepper,
    DxLoadPanel,
    PlaceAnOrder,
    ConfirmOrder,
  },
  data() {
    return {
      loaderPosition: { of: "#PlaceAnOrderRequestForm" },
      loaderVisible: false,
      user: this.$auth.user.UserDetails,
      steps: [
        {
          StepName: "Import List",
          ModalHeader: "Place An Order",
          ShowBackButton: false,
          ShowNextButton: true,
          NextButtonText: "Continue",
          ComponentRef: "placeAnOrderRef",
          ValidateStep: false,
        },
        {
          StepName: "Confirmation",
          ModalHeader:
            "Review your details to make sure everything looks right before submitting",
          ShowBackButton: true,
          ShowNextButton: true,
          NextButtonText: "Submit",
          ComponentRef: "confirmOrderRef",
          ValidateStep: false,
        },
      ],
      currentStepIdx: 0,
      completedStepIdx: 0,
      DisabledTooltipMessages: [],
      ImportedProductData: [],
    };
  },
  created: function () {},
  watch: {
    currentStepIdx(newValue) {
      if (newValue > this.completedStepIdx) {
        this.completedStepIdx = newValue;
      }
    },
  },
  computed: {
    IsCurrentStepValid() {
      return this.steps[this.currentStepIdx].ValidateStep
        ? this.$refs[
            this.steps[this.currentStepIdx].ComponentRef
          ].validateStep()
        : true;
    },
    currentStepName() {
      this.$emit("set-title", this.steps[this.currentStepIdx].ModalHeader);
      return this.steps[this.currentStepIdx].StepName;
    },
    continueBtnHoverText() {
      return this.IsCurrentStepValid
        ? "All Required fields must be filled in to continue."
        : "";
    },
    diabledToolTip() {
      return this.getDisabledTooltips();
    },
  },
  methods: {
    setImportedProducts(products) {
      this.ImportedProductData = [];
      this.ImportedProductData = products;
    },
    hideModal() {
      this.$emit("hide-modal");
    },
    sendData() {
      //Final Object
      const orderJsonData = {
        Company_RecID: this.user.Company_RecID,
        Contact_RecID: this.user.Contact_RecID,
        ClientRequestObj: this.ImportedProductData,
      };
      // console.log("Final Object :::)", orderJsonData);
      this.savePlaceAnOrder(orderJsonData);
    },
    savePlaceAnOrder(productJson) {
      this.loaderVisible = true;
      let th = this;
      const URL = `https://api.ccr.net/ColoM360/clientrequest/additions`;
      this.$axios.post(URL, productJson).then(() => {
        notify(
          {
            message: "Request submitted successfully!",
            position: {
              my: "center top",
              at: "center top",
            },
            width: "300px",
          },
          "success",
          5000
        );
        th.loaderVisible = false;
        th.hideModal();
      });
    },
    checkNextStep() {
      if (this.currentStepIdx + 1 === this.steps.length) {
        this.sendData();
      } else {
        this.currentStepIdx++;
      }
    },
    onRequestTypeClick(type) {
      // this.checkNextStep();
    },
    setDisabledTooltip(disabledTooltip) {
      this.DisabledTooltipMessages = [];
      this.DisabledTooltipMessages = disabledTooltip;
    },
    getDisabledTooltips() {
      let msgs = "";
      if (this.DisabledTooltipMessages.length === 0)
        return "All Required fields must be filled in to continue.";
      this.DisabledTooltipMessages.forEach((msg, i) => {
        msgs +=
          "<i>- " +
          msg +
          "</i>" +
          (this.DisabledTooltipMessages.length - 1 !== i ? "<br/>" : "");
      });
      return msgs;
    },
  },
};
</script>
<style lang="scss" scoped>
#order-d-main-section {
  height: 400px;
  padding: 0;
  overflow-y: 0;
  overflow-x: hidden;
}
</style>